let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files

  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/product-form.js?v=57800217465557518881760095897");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/shopflo.bundle.js?306437");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/pubsub.js?v=91589951812414908291761126906");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/cart-notification.js?v=133508293167896966491760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/constants.js?v=132983761750457495441760095896");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/cart.js?v=95316439595850377071760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/cart-drawer.js?v=20316116728357646391761126904");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-scroll-tab.js?v=110537738839353943101760095897");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/collapsable-combo-section.js?v=23924472764557253391760095895");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-available-offers.js?306437");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-details.js?v=133041400373156940781760095896");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-recom-prods.js?306437");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/edd-section.js?v=100119633110064442781760095897");
  

  
  
    

  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/collapsible-content.css?v=40054841430043683651760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-accordion.css?v=181330424127687678861760774064");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-social-reviews.css?v=74717896916299017681760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-available-offers.css?v=112077318425957018091760095898"); 
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-scroll-tab.css?v=132899465197510878951760095897");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/new_serums_section.css?v=93889447425504097401760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/sunscreen-quiz-pdp.css?v=150892412449710366031760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/new-details-collapsable.css?v=21783054330784661661760095897");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-color-swatch.css?v=146727391458662814791760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/all.min.css?v=36347114306294163891760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-price.css?v=70172745017360139101760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-card.css?v=158102377163184793191761126905");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart.css?v=49529066954642232561760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-mega-menu.css?v=122458266873942644791760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-totals.css?v=45024014013762792871760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart-drawer.css?v=162987023708451632291760095897");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-discounts.css?v=152760482443307489271760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/searchtap.css?v=111603181540343972631760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-list-menu.css?v=151968516119678728991760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-search.css?v=165164710990765432851760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-menu-drawer.css?v=20646116693146970981760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart-notification.css?v=54116361853792938221760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-cart-items.css?v=47901327362710772261760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-collection-hero.css?v=150137544140055157131760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/quick-add.css?v=66647833350618835731760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-show-more.css?v=139536189637226996221760095897");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-swatch-input.css?v=61683592951238328641760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/component-swatch.css?v=68619770617697936771760095898");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/collapsable-combo-section.css?v=16640933633868879741760095895");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-feature-svg.css?v=107811230276467158871760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/npdp-recom-prods.css?v=79113754582887175411760095896");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1796/assets/edd-section.css?v=151752159037241140411760095897");


   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/details-modal.js?v=119528565511025453401760095898");
  loadScript("//www.dotandkey.com/cdn/shop/t/1796/assets/details-disclosure.js?v=13653116266235556501760095898");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
